import PropTypes from "prop-types";
import colors from "constants/colors";
import IconCheck from "components/shared/svg/IconCheck";

import { UspStyled, IconContainer } from "./Usps.styled";

export default function Usps({ items }) {
    return (
        <ul>
            {items?.map(item => (
                <UspStyled key={JSON.stringify(item)}>
                    <IconContainer>
                        <IconCheck fill={colors.peach} />
                    </IconContainer>
                    {item}
                </UspStyled>
            ))}
        </ul>
    );
}

Usps.defaultProps = {
    items: [
        "Boeken, e-books & tijdschriften",
        "Op werkdagen voor 17:00 besteld = vandaag verstuurd",
        "Bedrijven bestellen makkelijk op factuur",
        "Veilig betalen d.m.v. SSL-encryptie"
    ]
};

Usps.propTypes = {
    items: PropTypes.arrayOf(PropTypes.string)
};
